import { render, staticRenderFns } from "./EditorLessonItems.vue?vue&type=template&id=17d4e4a1&scoped=true"
import script from "./EditorLessonItems.vue?vue&type=script&lang=js"
export * from "./EditorLessonItems.vue?vue&type=script&lang=js"
import style0 from "./EditorLessonItems.vue?vue&type=style&index=0&id=17d4e4a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d4e4a1",
  null
  
)

export default component.exports